import { Component, inject } from '@angular/core';
import { AdminToastService } from './admin-toast.service';

@Component({
  selector: 'app-admin-toast-host',
  standalone: true,
  template: `
    <div class="cg-admin-toast-stack" aria-live="polite" aria-atomic="true">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="cg-admin-toast"
          [class.cg-admin-toast--success]="toast.variant === 'success'"
          [class.cg-admin-toast--error]="toast.variant === 'error'"
          role="status"
        >
          <span class="cg-admin-toast__message">{{ toast.message }}</span>
          <button type="button" class="cg-admin-toast__close" (click)="toastService.dismiss(toast.id)" aria-label="Dismiss">
            ×
          </button>
        </div>
      }
    </div>
  `,
})
export class AdminToastHostComponent {
  readonly toastService = inject(AdminToastService);
}
